import styled                  from 'styled-components';

import { TypographyVariants  } from 'src/components/common/typography';

import { StepElementVariants } from 'src/components/features/qmmsg/detail/step-element';

import { cssFlexColumn,
         themeColors         } from 'src/providers/theme/shared';



type StepFlowLookAndFeel = {
  paddings: number[];
  gap: number;
  stepGap: number;

  backgroundColor: string;
  borderColor: string;

  headerTypographyVariant: TypographyVariants;
  stepElementVariant: StepElementVariants;
}

const stepflow_light: StepFlowLookAndFeel = {
  paddings: [16],
  gap: 15,
  stepGap: 12,

  backgroundColor: themeColors.PrimaryWhite,
  borderColor: themeColors.BorderPastelBluePrimary2,

  headerTypographyVariant: 'blackw400s14lh18',
  stepElementVariant: 'light',
}

export type StepFlowVariants = 'light';

export const stepflow_variants: Map<StepFlowVariants, StepFlowLookAndFeel> = 
  new Map<StepFlowVariants, StepFlowLookAndFeel>([
    ['light', stepflow_light],
  ]);

export const Wrapper = styled.div<{
  lookAndFeel: StepFlowLookAndFeel;
}>`
  width: 100%;
  position: relative;
  border: 1px solid ${(args) => args.lookAndFeel.borderColor};
  border-radius: 12px;
  background-color: ${(args) => args.lookAndFeel.backgroundColor} !important;
  padding: ${(args) => args.lookAndFeel.paddings[0]}px;
`;

export const Container = styled.div<{
  lookAndFeel: StepFlowLookAndFeel;
}>`
  ${cssFlexColumn};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.gap}px;
`

export const Steps = styled.div<{
  lookAndFeel: StepFlowLookAndFeel;
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.stepGap}px;
`
